<template>
	<b-modal ref="modal" title="Cancel subscription" :busy="loading>0">
		<b-form-group label="Reason for unsubscribing">
			<b-form-select :options="[
				{ value: null, text: 'Not specified' },
				{ value: 'too_expensive', text: 'It\'s too expensive' },
				{ value: 'missing_features', text: 'Some features are missing' },
				{ value: 'switched_service', text: 'I\'m switching to a different service' },
				{ value: 'unused', text: 'I don\'t use the service enough' },
				{ value: 'customer_service', text: 'Customer service was less than expected' },
				{ value: 'too_complex', text: 'Ease of use was less than expected' },
				{ value: 'low_quality', text: 'Quality was less than expected' },
				{ value: 'other', text: 'Other reason' },
			]" v-model="cancel.feedback"></b-form-select>
		</b-form-group>
		<b-form-group label="Details" v-show="cancel.feedback=='other'">
			<b-form-textarea v-model="cancel.comment"></b-form-textarea>
		</b-form-group>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{ cancel: cancel_fn }">
			<div class="w-100">
				<div class="float-right">
					<b-spinner v-show="loading>0" small label="Spinning" class="mr-3"></b-spinner>
					<b-button variant="danger" type="submit" @click="submitCancel()" class="mr-2">
						Confirm
					</b-button>
					<b-button @click="cancel_fn()">
						Close
					</b-button>
				</div>
			</div>
		</template>
	</b-modal>
</template>

<script>
export default {
	data: () => ({
		loading: 0,
		error: null,
		cancel: {
			feedback: null,
			comment: null,
		},
	}),
	methods: {
		show() {
			this.$refs.modal.show();
		},
		submitCancel() {
			this.loading++;
			this.$api.delete('subscription', { feedback: this.cancel.feedback || '', comment: this.cancel.comment||'' }).then(() => {
				this.$refs.modal.hide();
				this.$bvToast.toast('Subscription canceled', {
					title: 'Success',
					variant: 'success',
					solid: true,
				});
			}, err => this.error = err).finally(() => this.loading--);
		},
	},
}
</script>
